import { useEffect } from 'react';

import './styles.scss';

function Button({ text, type, onClick, disabled, scrollOnLoad }) {
  useEffect(() => {
    if (scrollOnLoad) {
      document.getElementById('btn').scrollIntoView({ behavior: 'smooth' });
    }
  });

  switch (type) {
    case 'primary':
      return (
        <div
          id="btn"
          className={
            !disabled
              ? 'Button-primary-container-a'
              : 'Button-primary-container-d'
          }
          onClick={!disabled ? onClick : null}
        >
          <div className="Button-primary-content">
            <p className="Button-primary-text">{text}</p>
          </div>
        </div>
      );
    case 'primary-bigger':
      return (
        <div
          id="btn"
          className={
            !disabled
              ? 'Button-primary-bigger-container-a'
              : 'Button-primary-bigger-container-d'
          }
          onClick={!disabled ? onClick : null}
        >
          <div className="Button-primary-content">
            <p className="Button-primary-text">{text}</p>
          </div>
        </div>
      );
    case 'secondary':
      return (
        <div
          id="btn"
          className={
            !disabled
              ? 'Button-secondary-container-a'
              : 'Button-secondary-container-d'
          }
          onClick={!disabled ? onClick : null}
        >
          <div className="Button-secondary-content">
            <p
              className={
                !disabled
                  ? 'Button-secondary-text-a'
                  : 'Button-secondary-text-d'
              }
            >
              {text}
            </p>
          </div>
        </div>
      );
    case 'secondary-small':
      return (
        <div
          id="btn"
          className={
            !disabled
              ? 'Button-secondary-small-container-a'
              : 'Button-secondary-small-container-d'
          }
          onClick={!disabled ? onClick : null}
        >
          <div className="Button-secondary-small-content">
            <p
              className={
                !disabled
                  ? 'Button-secondary-small-text-a'
                  : 'Button-secondary-small-text-d'
              }
            >
              {text}
            </p>
          </div>
        </div>
      );
    default:
      return null;
  }
}

export default Button;
